module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-sell-spa.fde476ef.png";